module.exports = __webpack_public_path__ + "static/media/logo-crecer-plee-white.3ab51f23.png";